import React from "react";
import styles from "./Broadcast.module.css";

interface Props {
	tabSelected: "streaming" | "scheduled" | "archived";
	setTabSelected: (v: "streaming" | "scheduled" | "archived") => void;
}
export default function StatusSelector({ tabSelected, setTabSelected }: Props) {
	return (
		<section className={styles.broadcastNav}>
			<nav>
				<ul>
					<li
						className="text-body"
						style={tabSelected === "streaming" ? { borderBottom: "4px solid rgb(0, 94, 164)" } : {}}
						onClick={() => setTabSelected("streaming")}
					>
						LIVE
					</li>

					<li
						className="text-body"
						style={tabSelected === "scheduled" ? { borderBottom: "4px solid rgb(0, 94, 164)" } : {}}
						onClick={() => setTabSelected("scheduled")}
					>
						UPCOMING
					</li>

					<li
						className="text-body"
						style={tabSelected === "archived" ? { borderBottom: "4px solid rgb(0, 94, 164)" } : {}}
						onClick={() => setTabSelected("archived")}
					>
						RECENT
					</li>
				</ul>
			</nav>

			{/* <select onChange={(e) => setTabSelected(e.target.value)}>
				<option
					value="streaming"
					style={tabSelected === "streaming" ? { borderBottom: "4px solid rgb(0, 94, 164)" } : {}}
				>
					LIVE
				</option>

				<option
					value="scheduled"
					style={tabSelected === "scheduled" ? { borderBottom: "4px solid rgb(0, 94, 164)" } : {}}
				>
					UPCOMING
				</option>

				<option
					value="archived"
					style={tabSelected === "archived" ? { borderBottom: "4px solid rgb(0, 94, 164)" } : {}}
				>
					RECENT
				</option>
			</select> */}
		</section>
	);
}
